<!--
 * @Author: lsr lsr@qq.com
 * @Date: 2022-07-09 11:46:07
 * @LastEditors: lsr lsr@qq.com
 * @LastEditTime: 2022-07-09 14:03:46
 * @FilePath: \YHB_H5\src\pages\download\sysdownload.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div v-if="browser == false" class="download-content">
		<img src="../../assets/rys-down-bg.png" class="bg" />
		<div class="download-bottom"><div class="download-btn" type="default" @click="download">下载如意刷APP</div></div>
	</div>
	<div v-else class="download-content"><img @click="browser = false" src="../../assets/rys-down-close.png" class="bg" /></div>
</template>

<script>
import { downloadApp } from '@/api/index';
// import { Toast } from 'vant';

export default {
	data() {
		return {
			browser: false
		};
	},
	mounted() {
		// this.getisweixing();
	},

	methods: {
		// 判断是否在 微信浏览器
		getisweixing() {
			var wx = window.navigator.userAgent.toLowerCase();
			if (wx.match(/MicroMessenger/i) == 'micromessenger') {
				// console.log('是微信浏览器默认走微信')
				this.browser = true;
				return; // 是微信端
			} else {
				// console.log('不是微信浏览器绘制原生。');
				this.browser = false;
				return;
			}
		},
		// 下载
		async download() {
			await this.getisweixing();
			if (this.browser) {
				// Toast({
				// 	message: '请点击右上角选择在浏览器中打开',
				// 	duration: 3000
				// });
				return;
			}
			downloadApp('RYS').then(res => {
				let u = navigator.userAgent;
				let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				if (isAndroid) {
					window.location.href = res.msg;
				} else {
					window.location.href =`itms-apps://itunes.apple.com/app/id1627223110?mt=8`
				}
			});
		}
	}
};
</script>

<style lang="scss">
.download-content {
	// position: relative;
	// // max-width: 750px;
	// margin: auto;
	// height: 100%;
	// position: relative;
	// max-width: 750px;
	// margin: auto;
	height: 100vh;
	max-width: 100%;
}

.bg {
	max-width: 100%;
	height: 100%;
	// max-width: 100%;
}
// .download-close {
// 	position: relative;
// 	max-width: 750px;
// 	margin: auto;
// 	.bg {
// 		max-width: 100%;
// 	}
// }
.download-bottom {
	position: absolute;
	top: 70%;
	width: 100%;
	text-align: center;
	padding-bottom: 20px;

	.download-btn {
		width: 310px;
		height: 45px;
		background: linear-gradient(270deg, #d69c63 0%, #f7ce9e 100%);
		box-shadow: 1px 5px 12px 1px rgba(247, 206, 158, 0.7);
		border-radius: 28px 28px 28px 28px;
		opacity: 1;
		margin: auto;
		line-height: 45px;
		font-size: 18px;
		font-weight: 500;
		color: #1d1f24;
	}
}
</style>
